import { cn } from "@/utils/tailwind";
import { IconType } from "@/utils/types";

interface SectionIconProps {
  variant: "info" | "success" | "warning" | "error";
  Icon: IconType;
}

export function EventSectionIcon({
  variant,
  Icon,
}: Readonly<SectionIconProps>) {
  return (
    <div
      className={cn(
        "inline-flex items-center justify-center size-10 rounded-lg overflow-hidden",
        variant === "info"
          ? "bg-info-50"
          : variant === "success"
            ? "bg-success-50"
            : variant === "warning"
              ? "bg-warning-50"
              : "bg-error-50",
      )}
    >
      <Icon
        className={cn(
          "size-6",
          variant === "info"
            ? "text-info-500"
            : variant === "success"
              ? "text-success-500"
              : variant === "warning"
                ? "text-warning-500"
                : "text-error-500",
        )}
      />
    </div>
  );
}
